import { render, staticRenderFns } from "./CreateModel.vue?vue&type=template&id=09303662&scoped=true&"
import script from "./CreateModel.vue?vue&type=script&lang=js&"
export * from "./CreateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09303662",
  null
  
)

export default component.exports